import React from 'react';
import { BrandColor } from '@styleseat/brand';

type BasicHeartIconProps = {
  width?: number;
  height?: number;
  outlineColor?: string;
  fillColor?: string;
} & React.SVGProps<SVGSVGElement>;

export const BasicHeartIcon = ({
  width = 24,
  height = 24,
  viewBox = '0 0 41 40',
  outlineColor = BrandColor.BackInBlack,
  fillColor = BrandColor.Red,
}: BasicHeartIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.3378 4.49337C24.1207 3.62069 25.676 3.33325 28.0888 3.33328C34.2633 3.35885 38.8334 8.56633 38.8334 15.1997C38.8334 20.2628 36.0104 25.1537 30.752 29.8831C27.9919 32.3655 24.4679 34.8221 21.9441 36.129L20.5001 36.8768L19.0561 36.129C16.5323 34.8221 13.0082 32.3655 10.2481 29.8831C4.9898 25.1537 2.16675 20.2628 2.16675 15.1997C2.16675 8.49536 6.69414 3.33325 12.9243 3.33325C15.2505 3.33325 16.8856 3.64788 18.7031 4.54681C19.3359 4.85978 19.9304 5.23102 20.4834 5.65952C21.0585 5.20557 21.6778 4.81647 22.3378 4.49337Z"
      fill={outlineColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.5229 27.4048C33.1436 23.2489 35.5 19.1666 35.5 15.1999C35.5 10.315 32.3137 6.6843 28.0818 6.66676C26.145 6.66675 25.0765 6.86424 23.8032 7.48746C23.02 7.87081 22.3252 8.38833 21.7191 9.046L20.5039 10.3646L19.2776 9.05637C18.6848 8.42403 18 7.91803 17.2252 7.53482C15.9135 6.88606 14.7738 6.66675 12.9242 6.66675C8.6394 6.66675 5.5 10.2463 5.5 15.1999C5.5 19.1666 7.85637 23.2489 12.4771 27.4048C14.9964 29.6706 18.2351 31.935 20.5 33.1229C22.7649 31.935 26.0036 29.6706 28.5229 27.4048Z"
      fill={fillColor}
    />
  </svg>

);

export default BasicHeartIcon;
